import type {Media} from "crqlar-react-common/dist/models/common/media.model";
import {useOrganization} from "crqlar-react-common/dist/state/auth.reducer";
import {getScaledUrl, MediaSize} from "crqlar-react-common/dist/utils/media.util";
import {useTranslation} from "react-i18next";
import {useQuery} from "react-query";
import {
    fetchLogoDataUrl,
    loadSurveyExportBranding,
    type SurveyExportBranding
} from "./surveyExport.util";

const SURVEY_EXPORT_ASSETS_QUERY_KEY = 'surveyExportAssets';

export type SurveyExportAssets = {
    organizationName: string
    logoDataUrl?: string
    logoUrl?: string
    branding?: SurveyExportBranding
};

export const useSurveyExportAssets = (enabled: boolean): SurveyExportAssets => {
    const {t, i18n} = useTranslation();
    const organization = useOrganization();

    const logoMedia: Media | undefined = organization?.media?.mediaURI
        ? organization.media
        : organization?.logo?.mediaURI
            ? organization.logo
            : undefined;

    const logoUrl = getScaledUrl(logoMedia, MediaSize.MEDIUM_300, MediaSize.MEDIUM_300);

    const query = useQuery(
        [SURVEY_EXPORT_ASSETS_QUERY_KEY, logoUrl, i18n.language],
        async () => ({
            logoDataUrl: await fetchLogoDataUrl(logoUrl),
            branding: await loadSurveyExportBranding(t),
        }),
        {enabled, refetchOnWindowFocus: false, staleTime: Infinity}
    );

    return {
        organizationName: organization?.name || '',
        logoDataUrl: query.data?.logoDataUrl,
        logoUrl: logoUrl || undefined,
        branding: query.data?.branding,
    };
};
